module.exports = __webpack_public_path__ + "img/pv.4ed780ef.png";